"use client";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-circle.tsx
var ProgressCircle = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useProgressContext().getCircleProps(), props);
	return /* @__PURE__ */ jsx(ark.svg, {
		ref,
		...mergedProps
	});
});
ProgressCircle.displayName = "ProgressCircle";
//#endregion
export { ProgressCircle };
